<template>
    <div class="ResponesBody" :style="this.BackGroundColor">
        <h1>You used: {{this.DisplayData}}ms.</h1>
        <h2>{{getRating()}}</h2>
    </div>
    
</template>

<script>
export default {
    props:["DisplayData"],
    data:function(){
        return {
            BackGroundColor: {"background-color":`grey`}
        }
    },
    methods:{
        getRating:function(){
            if (this.DisplayData < 200)
            {
                this.BackGroundColor['background-color'] = "#ff9000";
                return "Super Human";
            }
            if (this.DisplayData < 300)
            {
                this.BackGroundColor['background-color'] = "lime";
                return "Blazing Fast";
            }
                
            if (this.DisplayData < 500)
            {
                this.BackGroundColor['background-color'] = "cyan";
                return "Pretty Good";
            }
                
            if (this.DisplayData < 700)
            {
                this.BackGroundColor['background-color'] = "purple";
                return "Not Bad But Could be Better";
            }
                
            if (this.DisplayData < 1000)
            {
                this.BackGroundColor['background-color'] = "brown";
                return "Better Luck Next Time";
            }
                
        }
    }
}
</script>

<style scoped>
    .ResponesBody{
        /* background-color: chartreuse; */
        color: #232323;
        padding: 50px;
        border-radius: 20px;
    }
</style>